module.exports = __webpack_public_path__ + "static/img/company_header_bg.75c971a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company_header_bg.png
// module id = zv7m
// module chunks = 0